module.exports = __webpack_public_path__ + "media/newstyle/images/card-icon-1-ebeba61497aec32b1970c906570bd055.svg";